<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <template #footer>
      <a-button key="back" @click="onClose">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="onSubmit">保存</a-button>
      <a-popconfirm title="提交之后数据将不能修改，您确认要提交吗？" @confirm="onSubmitFun">
        <a-button key="submit" type="primary" :loading="confirmLoading">提交</a-button>
      </a-popconfirm>
    </template>
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
        <a-form-item label="firstReviewer" name="firstReviewer">
          <a-input v-model:value="form.firstReviewer" />
        </a-form-item>
        <a-form-item label="secondReviewer" name="secondReviewer">
          <a-input v-model:value="form.secondReviewer" />
        </a-form-item>
        <a-form-item label="isSubmit" name="isSubmit">
          <a-input v-model:value="form.isSubmit" />
        </a-form-item>
        <a-form-item label="auditStatus" name="auditStatus">
          <a-input v-model:value="form.auditStatus" />
        </a-form-item>
        <a-form-item label="firstAuditStatus" name="firstAuditStatus">
          <a-input v-model:value="form.firstAuditStatus" />
        </a-form-item>
        <a-form-item label="secondAuditStatus" name="secondAuditStatus">
          <a-input v-model:value="form.secondAuditStatus" />
        </a-form-item>
      </div>
      <a-row :gutter="[24, 8]">
        <a-col :span="12">
          <a-form-item label="兑现年份" name="year">
            <!-- <YearPicker style="width: 100%" v-model:value="form.year" :format="dateFormat.DATE_YEAR" :showTime="false"
              @change="getIsAllowData" /> -->
            <a-select v-model:value="form.year" :options="form.yearArr" placeholder="请选择" @change="getIsAllowData" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="企业名称" name="companyName">
            <a-input :disabled="true" v-model:value="form.companyName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="统一社会信用代码" name="oraganizationCode">
            <a-input :disabled="true" v-model:value="form.oraganizationCode" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="企业注册地址" name="detailedAddress">
            <a-input :disabled="true" v-model:value="form.detailedAddress" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="经办人" name="agent">
            <a-input v-model:value="form.agent" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="经办人联系电话" name="agentPhone">
            <a-input v-model:value="form.agentPhone" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="经办人身份证号" name="agentIdCard">
            <a-input v-model:value="form.agentIdCard" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="邮箱" name="email">
            <a-input v-model:value="form.email" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="依据政策拟申请金额（元）" name="amountApplied">
            <a-inputNumber  :disabled="true" style="width: 100%" v-model:value="form.amountApplied" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="12">
          <a-form-item label="授权日期" name="authorizationDate">
            <DatePicker style="width: 100%" v-model:value="form.authorizationDate" :format="dateFormat.DATE_DAY"
              :showTime="false" />
          </a-form-item>
        </a-col> -->
        <a-col :span="12">
          <a-form-item label="开户银行（基本户）" name="openingBank">
            <a-input :disabled="form.isEdit" v-model:value="form.openingBank" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="开户银行账号" name="accountNumber">
            <a-input :disabled="form.isEdit" v-model:value="form.accountNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="开户银行行号" name="lineNumber">
            <a-input :disabled="form.isEdit" v-model:value="form.lineNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="上年度营业收入（元）" name="operatingIncome">
            <a-inputNumber style="width: 100%" v-model:value="form.operatingIncome"  @blur="handleBlur" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item name="operatingIncomeFile">
            <template #label>
              <div>
                上年度营业收入印证资料<span style="color: #ff4d4f">（上传资产负债表、利润表以及现金流量表加盖公章扫描在一个附件(PDF格式)）</span>
              </div>
            </template>
            <file-upload v-model:value="form.operatingIncomeFile" :count="1" :size="800" :isPdf="true" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="上年度研发费用金额（元）" name="devCost">
            <a-inputNumber style="width: 100%" v-model:value="form.devCost"  @blur="handleBlur" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item name="devDataFile">
            <template #label>
              <div>
                上年度研发费用印证资料<span style="color: #ff4d4f">（上传企业所得税申报表中A107010、A107012加盖公章扫描在一个附件(PDF格式)）</span>
              </div>
            </template>
            <file-upload v-model:value="form.devDataFile" :count="1" :size="800" :isPdf="true" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="研发费用占比%" name="devProportion">
            <a-input :disabled="true" v-model:value="form.devProportion" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="研发费用奖励金额（元）" name="rewardAmount">
            <a-input :disabled="true" v-model:value="form.rewardAmount" placeholder="请输入" />
          </a-form-item>
        </a-col>
          <a-col :span="24">
              <a-form-item label="政策依据" name="policyBasis">
                  <a-textarea :disabled="true" v-model:value="form.policyBasis" :rows="8" :maxlength="500"/>
              </a-form-item>
          </a-col>
        <!-- <a-col :span="12">
          <a-form-item label="开户行许可证" name="bankPermitFile">
            <file-upload :disabled="true" v-model:value="form.bankPermitFile" />
          </a-form-item>
        </a-col> -->


        <a-col :span="24">
          <a-form-item name="correspondingCorroboratingDataFile">
            <template #label>
              <div>
                高企证书<span style="color: #ff4d4f">（上传（PDF））</span>
              </div>
            </template>
            <file-upload v-model:value="form.correspondingCorroboratingDataFile" :count="1" :size="800" :isPdf="true" />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="12">
          <a-form-item name="promiseFile" slots="label">
            <template #label>
              <div>
                <span>承诺书</span> &nbsp;&nbsp;&nbsp; <a @click="getMoban"> 承诺书下载 </a>
              </div>
            </template>
            <file-upload v-model:value="form.promiseFile" />
          </a-form-item>
        </a-col> -->
      </a-row>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
  <a-modal v-model:visible="isAllowVisible" :closable="false" :maskClosable="false">
    <template #footer>
      <div>
        <a-button type="primary" @click="handleOk">去填报</a-button>
      </div>
    </template>
    <h3>{{ form.year }}年对应的企业积分制未填报！</h3>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { sys_policy, sys_devCost } from "@/api/policyService";
// import YearPicker from "@/components/form/datePicker/YearPicker";
// import DatePicker from "@/components/form/datePicker/DatePicker";
import { policy, dateFormat } from "@/config/variableConfig";
import { message } from "ant-design-vue";
import { ls } from "@/utils/util";
import { file_service } from "@/api/adminService";
import axios from "axios";

export default {
  name: "UserModal",
  components: {  },
  mixins: [formMixin],
  data() {
    return {
      policy,
      dateFormat,
      isAllowVisible: false,
      form: {
        id: null,
      },
      rules: {
        agent: [dataCheck.required({})],
        agentPhone: [dataCheck.mobile_phone, dataCheck.required({})],
        agentIdCard: [dataCheck.id_num, dataCheck.required({})],
        email: [dataCheck.email, dataCheck.required({})],
        amountApplied: [dataCheck.required({ type: 'number' })],
        highNumber: [dataCheck.required({})],
        // authorizationDate: [dataCheck.required({})],
        openingBank: [],
        accountNumber: [],
        lineNumber: [],
        bankPermitFile: [],
        promiseFile: [],
        correspondingCorroboratingDataFile: [dataCheck.required({})],
        year: [dataCheck.required({})],
        id: [],
        firstReviewer: [],
        secondReviewer: [],
        isSubmit: [],
        auditStatus: [],
        firstAuditStatus: [],
        secondAuditStatus: [],
        operatingIncome: [dataCheck.required({ type: 'number' })],
        devCost: [dataCheck.required({ type: 'number' })],
        devProportion: [],
        rewardAmount: [],
        operatingIncomeFile: [dataCheck.required({})],
        devDataFile: [dataCheck.required({})],
      },
      submitUrl: sys_devCost.saveupdate
    }

  },
  methods: {
    handleBlur() {
        if(this.form.operatingIncome && this.form.devCost){
            this.form.devProportion =((this.form.devCost / this.form.operatingIncome) * 100) .toFixed(2)
            this.form.rewardAmount = this.form.devCost * 0.05 > 500000 ? 500000:this.form.devCost * 0.05
            this.form.amountApplied = this.form.rewardAmount
        }
    },
    getIsAllowData(value) {
      this.getAction({
        url: sys_policy.isFillIn + value
      }).then(res => {
        if (res) {
          this.postAction({
            url: sys_policy.isAllow,
            params: { cashingTypeValue: '25', year: value }
          }).then(res => {
            if (res.result == 'false') {
              message.warning('不在兑现时间范围内！', this.resetForm)
            } else {
              this.form.firstReviewer = res.firstReviewer
              this.form.secondReviewer = res.secondReviewer
            }
          })
        } else {
          this.isAllowVisible = true
        }
      })
    },
    handleOk(){
      this.$router.push({ path: '/sys/manage' })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields('year')
    },
    getMoban() {
      if (this.form.year) {
        this.postAction({
          url: sys_policy.getMoban,
          params: { cashingTypeValue: '25', year: this.form.year }
        }).then(res => {
          this.fileDowload(res)
        })
      } else {
        message.warning('请选择年份！')
      }
    },
    fileDowload(r) {
      if (r) {
        let name = r.split('|')[1];
        axios({
          methods: 'get',
          url: file_service.download + r,
          responseType: 'blob',
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            Authorization: 'Bearer' + ls.get('token') || ''
          }
        }).then(data => {
          const blob = new Blob([data.data], { type: "application/vnd.ms-excel;charset=utf-8" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a"); // 创建a标签
          link.href = url;
          link.download = decodeURIComponent(name);// 文件重命名，若无需重命名，将该行删去
          link.click();
          URL.revokeObjectURL(url); // 释放内存
        })
      } else {
        message.warning('请确认承诺书是否已经上传！')
      }
    },
    onSubmitFun(){
      this.form.isSubmit = 5
      this.onSubmit()
    }
  },
  watch: {
    visible: {
      handler(oldValue) {
        if (this.form.yearArr.length == 1) {
          if (oldValue) {
            this.getIsAllowData(this.form.year)
          }
        }
      },
    }
  }
}
</script>
<style scoped lang="less"></style>
